import { Component, ElementRef, AfterViewInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { HomeService } from './home.service';
import { StaticMemory } from 'src/app/handler/static_memory';
import KeenSlider, { KeenSliderInstance } from 'keen-slider';
export interface PhotosApi {
  title?: string;
  subTitle: string;
  content: string;
  label?: string;
  url?: string;
  link?: string;
  bgColor?: string;
  labelColor?: string;
}
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  providers: [HomeService],
})
export class HomeComponent implements AfterViewInit {
  @ViewChild('sliderRef') sliderRef: ElementRef<HTMLElement>;
  @ViewChild('topSellingSliderRef') topSellingSliderRef: ElementRef<HTMLElement>;
  currentSlide: number = 0;
  dotHelper: Array<number> = [];
  slider: KeenSliderInstance = null;
  sliderArray: Array<PhotosApi> = [];

  categoriesArray: Array<any> = [];

  topSellingCurrentSlide: number = 0;
  topSellingDotHelper: Array<number> = [];
  topSellingSlider: KeenSliderInstance = null;
  topSellingSliderArray: Array<any> = [];

  data: any;
  value: any;
  errorMessage: string;
  loading = false;
  currentTabIndex = 2;
  totalRowLength: any;
  paginatorParam = null;
  paginationArray = [];
  pageSizeArr = [{ value: 5 }, { value: 10 }, { value: 20 }];
  selectedPageSize = 5;
  paginationIndex = 0;
  limit: number = 10;

  menuHidden: boolean = false;

  latitude: number | undefined;
  longitude: number | undefined;

  constructor(private router: Router, private service: HomeService) {
    this.menuHidden = StaticMemory.menuHidden;
  }

  ngOnInit(): void {
    try {
      this.getHomeSliderSection();
      this.getCategories();
      this.getSellingProducts();
    } catch (e) {}
  }

  onShopNowClick(link: string): void {
    window.location.href = link;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const hash = window.location.hash;
      if (hash) {
        const linkElement = document.querySelector(`${hash}Anchor`) as HTMLAnchorElement;
        if (linkElement) {
          linkElement.click();
        }
      }
    }, 100);
  }

  ngOnDestroy(): void {
    if (this.slider) {
      this.slider.destroy();
    }
    if (this.topSellingSlider) {
      this.topSellingSlider.destroy();
    }
  }

  getHomeSliderSection(): void {
    this.loading = true;
    this.service.getHomeSliderSection({ groupName: 'HOMESLIDER' }).subscribe(
      (success) => {
        if (success.status && success.result && success.result.length) {
          const value = success.result[0];
          if (value.subSectionDetails && value.subSectionDetails.length) {
            for (let i = 0; i < value.subSectionDetails.length; i++) {
              const idx = value.subSectionDetails[i];
              this.sliderArray.push({
                title: idx.title,
                subTitle: idx.subTitle,
                content: idx.content,
                label: idx?.actions?.label ? idx?.actions[0]?.label : 'Shop Now',
                link: idx?.galleryDetails?.length
                  ? idx?.galleryDetails[0]?.linkLg
                  : 'assets/images/background_jompoi.jpg',
                url: idx?.actions?.length ? idx?.actions[0]?.url : 'https://xlayertechnologies.com',
                bgColor: idx?.actions?.length ? idx?.actions[0]?.backgroundColor : '#000000',
                labelColor: idx?.actions?.length ? idx?.actions[0]?.labelColor : '#000000',
              });
            }
            this.loading = false;
            setTimeout(() => {
              this.slider = new KeenSlider(this.sliderRef.nativeElement, {
                initial: this.currentSlide,
                slideChanged: (s) => {
                  this.currentSlide = s.track.details.rel;
                },
              });
              this.dotHelper = [...Array(this.slider.track.details.slides.length).keys()];
            }, 100);
          }
        } else {
          this.loading = false;
          this.errorMessage = success.message.toUpperCase();
        }
      },
      (error: any) => {
        this.loading = false;
        this.errorMessage = 'HTTP ERROR IN GET HOME SLIDER';
      },
    );
  }

  getCategories(): void {
    this.service.getCategories().subscribe(
      (success) => {
        if (success.status && success.result && success.result.length) {
          this.categoriesArray = success.result;
          this.categoriesArray[0].image.linkMd = 'assets/images/all-category.png';
        }
      },
      (error) => {},
    );
  }

  getSellingProducts(): void {
    this.service.getSellingProducts().subscribe(
      (success) => {
        if (success.status && success.result && success.result.length) {
          this.topSellingSliderArray = success.result;
          for (let i = 0; i < this.topSellingSliderArray.length; i++) {
            const idx = this.topSellingSliderArray[i];
            if (idx?.images && idx?.images.length) {
              idx.linkMd = idx.images[0].linkMd;
            }
          }
          setTimeout(() => {
            this.topSellingSlider = new KeenSlider(this.topSellingSliderRef?.nativeElement, {
              slides: { perView: 1, spacing: 10 },
              breakpoints: {
                '(min-width: 500px)': {
                  slides: { perView: 2, spacing: 5 },
                },
                '(min-width: 600px)': {
                  slides: { perView: 3, spacing: 5 },
                },
                '(min-width: 1000px)': {
                  slides: { perView: 5, spacing: 10 },
                },
              },
              initial: this.topSellingCurrentSlide,
              slideChanged: (s) => {
                this.topSellingCurrentSlide = s.track.details.rel;
              },
            });
          }, 100);
        }
      },
      (error) => {},
    );
  }

  onClickCategories(value: any): void {
    let subCatId: string = '';
    if (value.subCategoriesInfo && value.subCategoriesInfo.length) {
      subCatId = value.subCategoriesInfo[0]._id;
    }
    const queryParams = { catId: subCatId, pId: value._id };
    this.router.navigate(['/shop'], { queryParams });
  }

  // navigateToShop(catId: string): void {
  //   this.router.navigate(['/shop'], { queryParams: { catId: catId } });
  // }

  // navigateToEventDetails(link: string): void {
  //   window.location.href = link;
  // }

  // navigateToArticlesDetails(link: string): void {
  //   window.location.href = link;
  // }

  // prev(): void {
  //   if (this.categorySlider) {
  //     const viewportWidth = window.innerWidth;
  //     if (viewportWidth >= 1000) {
  //       this.categorySlider.moveToIdx(0);
  //     } else {
  //       this.categorySlider.prev();
  //     }
  //   }
  // }

  // next(): void {
  //   if (this.categorySlider) {
  //     const viewportWidth = window.innerWidth;
  //     if (viewportWidth >= 1000) {
  //       this.categorySlider.moveToIdx(2);
  //     } else {
  //       this.categorySlider.next();
  //     }
  //   }
  // }

  setDefaultImage(type: string, i: number): void {
    if (type === 'home-slider') {
      this.sliderArray[i].link = environment.placeholder;
    } else if (type === 'category') {
      this.categoriesArray[i].image.linkMd = environment.placeholder;
    } else {
      this.topSellingSliderArray[i].linkMd = environment.placeholder;
    }
  }
}
